import { makeAutoObservable } from 'mobx';
import {  MessageListingDto } from 'services/data-contracts';
import { PaginationInfo, getPaginationHeader } from 'libs/helper/paginationUtil';
import ServiceHelper from './ServiceHelper';
import { MessageFilterType } from 'types/CommonTypes';

export interface isValid {
  isValid: boolean;
}

class MessageFilterStore {
  messages: MessageListingDto[] = [];

  filteredMessages: MessageListingDto[] = [];

  paginationInfo: PaginationInfo | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  /**
   * @description 일별 예약 조회
   * @param filter
   */
  getMessages(filter: MessageFilterType) {
    ServiceHelper.adminMessageService
      ?.getMessages({
        page: filter.page ? filter.page - 1 : 0,
        size: filter.size ?? 40,
        searchKeyword: filter.keyword ?? '',
      })
      .then((res) => {
        this.messages = [...res.data];
        this.filteredMessages = [...res.data];
        this.paginationInfo = getPaginationHeader(res.headers);
      });
  }



  unmount() {
    this.messages = [];
  }
}

export default MessageFilterStore;
